import { render, staticRenderFns } from "./admindialog.vue?vue&type=template&id=44b9079e&scoped=true"
import script from "./admindialog.vue?vue&type=script&lang=js"
export * from "./admindialog.vue?vue&type=script&lang=js"
import style0 from "./admindialog.vue?vue&type=style&index=0&id=44b9079e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b9079e",
  null
  
)

export default component.exports